(() => {
  let mobileButton;
  const closeMobile = () => {
    document.body.classList.remove('reveal-mobile-nav');
    if (mobileButton) {
      mobileButton.setAttribute('aria-expanded', 'false');
      mobileButton.focus();
    }
  };
  document.addEventListener('click', event => {
    if (!document.querySelector('[data-leivip-menu]')) return;
    const toggle = event.target.closest('#shopify-section-header button.mobile-nav-toggle');
    const dismiss = event.target.closest('.mobile-navigation-drawer .mobile-nav-toggle');
    const shade = event.target.closest('.page-shade, .header-shade');
    if (dismiss || (shade && document.body.classList.contains('reveal-mobile-nav'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobile();
      return;
    }
    if (!toggle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    mobileButton = toggle;
    let drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer) {
      const source = document.querySelector('.mobile-navigation-drawer-template');
      if (!source) return;
      const holder = document.createElement('div');
      holder.innerHTML = source.textContent.trim();
      drawer = holder.firstElementChild;
      document.getElementById('shopify-section-header').after(drawer);
    }
    drawer.id = 'lm-mobile-drawer';
    toggle.setAttribute('aria-controls', drawer.id);
    const open = !document.body.classList.contains('reveal-mobile-nav');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.add('enable-mobile-nav-transition');
    document.body.classList.toggle('reveal-mobile-nav', open);
    if (open) drawer.querySelector('.mobile-nav-toggle')?.focus();
  }, true);
  let hoverButton = null;
  let hoverTimer;
  const roots = () => [...document.querySelectorAll('[data-leivip-menu]')];
  const close = (root, restore = false) => {
    root.querySelectorAll('.lm-trigger[aria-expanded="true"]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
      if (restore) button.focus();
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.lm-trigger');
    if (button) {
      const root = button.closest('[data-leivip-menu]');
      const open = hoverButton === button || button.getAttribute('aria-expanded') !== 'true';
      hoverButton = null;
      close(root);
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    }
    roots().forEach(root => { if (!root.contains(event.target)) close(root); });
  });
  document.addEventListener('keydown', event => {
    const mobileDrawer = event.target.closest('.mobile-navigation-drawer');
    if (event.key === 'Escape' && mobileDrawer && !event.target.closest('.lm-fold[open]')) {
      closeMobile();
      event.preventDefault();
      return;
    }
    const root = event.target.closest('[data-leivip-menu]');
    if (!root) return;
    if (event.key === 'Escape') {
      close(root, true);
      const fold = event.target.closest('.lm-fold[open]');
      if (fold) { fold.open = false; fold.querySelector('summary').focus(); }
      event.preventDefault();
    }
    if (event.key === 'ArrowDown' && event.target.matches('.lm-trigger')) {
      const button = event.target;
      close(root);
      button.setAttribute('aria-expanded', 'true');
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      if (panel) { panel.hidden = false; panel.querySelector('a')?.focus(); }
      event.preventDefault();
    }
  });
  document.addEventListener('focusin', event => {
    roots().forEach(root => { if (!root.contains(event.target)) close(root); });
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const item = event.target.closest('.lm-top-item');
    const root = item?.closest('[data-leivip-menu]');
    if (!root || root.closest('.mobile-navigation-drawer')) return;
    clearTimeout(hoverTimer);
    if (item.contains(event.relatedTarget)) return;
    const button = item.querySelector('.lm-trigger');
    close(root);
    hoverButton = button;
    if (button) {
      const panel = root.querySelector('#' + button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
    }
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest('.lm-top-item');
    const root = item?.closest('[data-leivip-menu]');
    if (!root || root.closest('.mobile-navigation-drawer') || item.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => { close(root); hoverButton = null; }, 180);
  });
  roots().forEach(root => root.setAttribute('data-menu-ready', 'true'));
})();
